import React from 'react'
import PropTypes from 'prop-types'
import BasicTable from '../../../../../../atoms/BasicTable'
import Switch from '../../../../../../molecules/Switch'

function ColumnsDisplay ({ columns, onToggleFaceted }) {
  if (!columns || columns.length === 0) return null

  return (
    <div style={{ marginBottom: '16px' }}>
      <h4>Columns ({columns.length})</h4>
      <BasicTable className='opal-presentation-table zebra-rows'>
        <thead className='opt-thead'>
          <tr className='opt-tr'>
            <th className='opt-th'>Name</th>
            <th className='opt-th'>Expression</th>
            <th className='opt-th'>Type</th>
            <th className='opt-th'>Filterable</th>
            <th className='opt-th'>Sortable</th>
            <th className='opt-th'>Hidden</th>
            <th className='opt-th'>Faceted</th>
          </tr>
        </thead>
        <tbody className='opt-tbody'>
          {columns.map((col, idx) => (
            <tr className='opt-tr' key={idx}>
              <td className='opt-td'>{col.name}</td>
              <td className='opt-td'>
                {col.sourceExpression}
              </td>
              <td className='opt-td'>{col.dataType}</td>
              <td className='opt-td'>{col.filterable ? 'Yes' : 'No'}</td>
              <td className='opt-td'>{col.sortable ? 'Yes' : 'No'}</td>
              <td className='opt-td'>{col.hidden ? 'Yes' : 'No'}</td>
              <td className='opt-td'>
                {onToggleFaceted
                  ? (
                    <Switch
                      checked={!!col.faceted}
                      onChange={() => onToggleFaceted(idx, !col.faceted)}
                      size='small'
                    />
                  )
                  : (col.faceted ? 'Yes' : 'No')}
              </td>
            </tr>
          ))}
        </tbody>
      </BasicTable>
    </div>
  )
}

ColumnsDisplay.propTypes = {
  columns: PropTypes.array.isRequired,
  onToggleFaceted: PropTypes.func
}

export default ColumnsDisplay
